import { z } from 'zod';
export const merchantOnboard = z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string().email(),
    estimatedAnnualReturns: z.number(),
    // estimatedAnnualWarranties: z.number(),
});
//# sourceMappingURL=merchantOnboard.js.map